export enum FileKey {
  FILES = 'files',
  FILE_PERMISSIONS = 'filePermissions',
}
